import { Strategy } from 'utility-ts-strategy';

export let RegistrationActivityErrorTextStrategy = new Strategy({
  ADD: {
    text: 'could not be registered'
  },
  DROP: {
    text: 'could not be dropped'
  },
  SWAP: {
    text: 'could not be swapped'
  },
  WAITLIST: {
    text: 'could not be added to the waitlist'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_errors/strategies/registration_activity_text_strategy.ts